import BaseHttp from "@/api/httpHelper";
import apiGwClient from "@/api/api.gateway";
import type { IActivityResponse } from "@/types/response";
import type { IUpdateActivity, IGetActivity } from "@/types/requests";

class ActivityService extends BaseHttp {
  async getActivities(body: IGetActivity) {
    const { data } = await this.post<IActivityResponse>("/search", body, {
      requestKey: "getActivitiesById",
    });
    return data;
  }

  async revertActivity(id: string) {
    const { success, error } = await this.delete<string>(
      `/${id}`,
      {},
      { requestKey: "revertActivity" }
    );
    return { success, error };
  }

  async updateActivity(id: string, body: IUpdateActivity) {
    const { data, success, error } = await this.put<string>(`/${id}`, body, {
      requestKey: "updateActivity",
    });
    return { data, success, error };
  }
}

export default new ActivityService(apiGwClient, "/api/v1/activities");
